import { render, staticRenderFns } from "./Irroba.vue?vue&type=template&id=89f6b334"
import script from "./Irroba.vue?vue&type=script&lang=js"
export * from "./Irroba.vue?vue&type=script&lang=js"
import style0 from "./Irroba.vue?vue&type=style&index=0&id=89f6b334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports